var map = {
	"./en_US2.png": "9Tsb",
	"./mobile/en_US2.png": "GMIf",
	"./mobile/zh_CN2.png": "eK14",
	"./mobile/zh_HANT2.png": "7bGL",
	"./zh_CN2.png": "RUNy",
	"./zh_HANT2.png": "egFq"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "AAyH";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*2\.png$
// module id = AAyH
// module chunks = 1